import { Tooltip } from 'antd'
import Flex from 'components/Flex'
import BlacklistIcon from 'components/icons/BlacklistIcon'
import RejectIcon from 'components/icons/DriveTableIcon/Reject'
import Pagination from 'components/Pagination'
import ProgressCircle from 'components/ProgressCircle'
import SearchInput from 'components/SearchInput'
import { StyledTable } from 'components/TableStyles/TableStyles'
import ActionsStudent from 'modules/Students/Partials/StudentsInfoTable/ActionsStudent'
import StudentFilter from 'modules/Students/Partials/StudentsInfoTable/StudentFilter'
import StudentStatus from 'modules/Students/Partials/StudentsInfoTable/StudentStatus'
import {
  BlacklistHeading,
  NavWrapper,
  OverlayFlex,
  StyledLi,
  StyledP,
  StyledPNew,
  StyledSubTitle,
  TableTop,
} from 'modules/Students/Partials/StudentsInfoTable/Style/style'
import React, { useEffect, useState } from 'react'

import { FilterText } from 'components/FilterDiv'
import ShortlistIcon from 'components/icons/DriveTableIcon/Shortlist'
import PlacementHistoryWithResume from 'components/UIComponents/PlacementHistoryWithResume'

import AntdTabs from '../../../../components/AntdTab'
import { EmptyElement } from '../../../../components/CommonStyles'
import ConsentReasonDrawer from '../../../../components/ConsentReasonDrawer'
import ResumeDownload from '../../../../components/icons/DriveTableIcon/ResumeDownload'
import ResendIntiveIcon from '../../../../components/icons/ResendIntiveIcon'
import SuccessIcon from '../../../../components/icons/SubmitCloseIcon'
import ApprovedModelIcon from '../../../../components/icons/TPORequestsIcons/PopupIcon/ApprovedModelIcon'
import DeclinedPopupIcon from '../../../../components/icons/TPORequestsIcons/PopupIcon/DeclinedPopupIcon'
import CloseRoleDrawer from '../../../../components/UIComponents/CloseRolePopup'
import SucessfullPopup from '../../../../components/UIComponents/CloseRolePopup/SucessfullModelPopup'
import { getOptOutType } from '../../../../utils/helpers'
import { AllowButton } from '../../../ATS/Components/IndividualTable/Style'
import { IconContainer, IconText } from '../../../ATS/style'
import {
  NavBarLayoutFirst,
  NavBarLayoutSecond,
  StyledDivider,
  StyledEmail,
} from './Style/style'

// Utility function to extract unique specializations from degree list
const extractSpecializations = (degreeList) => {
  const specializationsMap = new Map()
  
  degreeList?.forEach(degree => {
    degree?.stream?.forEach(stream => {
      stream?.specialisation?.forEach(specMap => {
        const spec = specMap?.specialisation
        if (spec && spec.id && spec.name && spec.status === 1) {
          specializationsMap.set(spec.id, {
            id: spec.id,
            name: spec.name,
            status: spec.status
          })
        }
      })
    })
  })
  
  return Array.from(specializationsMap.values())
}

const StudentsInfoTable = props => {
  const {
    cardsData,
    studentsList,
    getSingleStudentData,
    deleteStudent,
    singleStudentData,
    onEditStudent,
    blacklistStudent,
    activeInactivateStatus,
    setUrl,
    degreeList,
    currentUrl,
    currentPage,
    setCurrentPage,
    setSelectedStudents,
    reInviteStudent,
    onSortValueChanged,
    loading,
    cruds,
    eventId,
    matchingTemplate,
    sendNotificationEmail,
    ScrollRef,
    search,
    setSearch,
    counter,
    setCounter,
    checkHeaderData,
    selectedStudents,
    SelectUnRestricted,
    SelectBlacklist,
    instituteCampusId,
    getStudentsListData,
    getConsentDrawerList,
    filterData,
    setFilterData,
    batchValue,
    setBatchValue,
    cardsDetails,
    rangeValue,
    setRangeValue,
    getJobRolePreview,
    getStudentPlacedList,
    getPlacementHistoryList,
    getPreview,
    selectAll,
    setSelectAll,
    setSelectedUniqueStudents,
    tabs,
    setTabsData,
    SelectOptOutlist,
    tabsData,
    selectedUniqueStudents,
    resendDisabled,
    handleResendClick,
    setBulkDownload,
    setPopUp,
    setUrlQuery,
    setNewUrlQuery,
    setCheckHeaderData,
    selected,
    setSelected,
    checkedDegreeData,
    setCheckedDegreeData
  } = props
  const [debounced, setDebounced] = useState(() => search)
  const [sortBy, setSortBy] = useState('')
  const [orderBy, setOrderBy] = useState('asc')
  const [showDeclinePopup, setShowDeclinePopup] = useState(false)
  const [showDeclinedDrawer, setShowDeclinedDrawer] = useState(false)
  const [showBlacklistedDrawer, setShowBlacklistedDrawer] = useState(false)
  const [showOptOutDrawer, setShowOptOutDrawer] = useState(false)
  const [showSuccessPopup, setShowSuccessPopup] = useState(false)
  const [showBlacklistPopup, setShowBlacklistPopup] = useState(false)
  const [consentReasonDrawer, setConsentReasonDrawer] = useState(false)
  const [rolesData, setRolesData] = useState([])
  const [consentReasonData, setConsentReasonData] = useState(null)
  const [isOpenHistory, setIsOpenHistory] = useState(false)
  const [selectedStudentId, setSelectedStudentId] = useState(null)

  const [approvalStatus, setApprovalStatus] = useState('')
 
  // const [batchValue, setBatchValue] = useState([])

  const isDisabled = selectedStudents.length === 0
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(search)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [search])

  useEffect(() => {
    if (search) {
      if (currentUrl?.includes('degreeStreamMapIds')) {
        const [baseUrl, queryString] = currentUrl.split('?')
        const searchParams = new URLSearchParams(baseUrl)

        const degreeStreamMapIds = searchParams.get('degreeStreamMapIds')
        const status = searchParams.get('status')
        const startBatch = searchParams.get('startBatch')
        const endBatch = searchParams.get('endBatch')
        const completionStart = searchParams.get('completionStart')
        const completionEnd = searchParams.get('completionEnd')
        const attendanceBacklisted = searchParams.get('attendanceBacklisted')
        const conductBacklisted = searchParams.get('conductBacklisted')
        const collegeFeeBacklisted = searchParams.get('collegeFeeBacklisted')

        let url = ''

        if (degreeStreamMapIds) {
          url += `degreeStreamMapIds=${degreeStreamMapIds}`
        }
        if (status) {
          url += `${url ? '&' : ''}status=${status}`
        }

        if (startBatch) {
          url += `${url ? '&' : ''}startBatch=${startBatch}`
        }

        if (endBatch) {
          url += `${url ? '&' : ''}endBatch=${endBatch}`
        }

        if (completionStart) {
          url += `${url ? '&' : ''}completionStart=${completionStart}`
        }

        if (completionEnd) {
          url += `${url ? '&' : ''}completionEnd=${completionEnd}`
        }

        if (attendanceBacklisted) {
          url += `${url ? '&' : ''}attendanceBacklisted=${attendanceBacklisted}`
        }

        // Append conductBacklisted if present
        if (conductBacklisted) {
          url += `${url ? '&' : ''}conductBacklisted=${conductBacklisted}`
        }

        // Append collegeFeeBacklisted if present
        if (collegeFeeBacklisted) {
          url += `${url ? '&' : ''}collegeFeeBacklisted=${collegeFeeBacklisted}`
        }

        setUrl(`${url}&searchBy=${search?.trim()}`)
      } else {
        if (currentUrl?.length === 0) {
          setUrl(`${currentUrl}&searchBy=${search?.trim()}`)
        } else {
          const urlParams = new URLSearchParams(currentUrl)
          if (urlParams.has('searchBy')) {
            urlParams.delete('searchBy')
          }
          const trimmedSearch = search?.trim()
          if (trimmedSearch) {
            urlParams.set('searchBy', trimmedSearch)
          }
          const updatedUrl = `${urlParams.toString()}`
          setUrl(updatedUrl)
        }
      }
    } else {
      if (currentUrl?.includes('degreeStreamMapIds')) {
        const [baseUrl, queryString] = currentUrl.split('?')
        const searchParams = new URLSearchParams(baseUrl)
        // Access the degreeStreamMapIds using the .get() method on searchParams
        const degreeStreamMapIds = searchParams.get('degreeStreamMapIds')
        const status = searchParams.get('status')
        const startBatch = searchParams.get('startBatch')
        const endBatch = searchParams.get('endBatch')
        const completionStart = searchParams.get('completionStart')
        const completionEnd = searchParams.get('completionEnd')
        const attendanceBacklisted = searchParams.get('attendanceBacklisted')
        const conductBacklisted = searchParams.get('conductBacklisted')
        const collegeFeeBacklisted = searchParams.get('collegeFeeBacklisted')
        let url = ''

        if (degreeStreamMapIds) {
          url += `degreeStreamMapIds=${degreeStreamMapIds}`
        }
        if (status) {
          url += `${url ? '&' : ''}status=${status}`
        }

        if (startBatch) {
          url += `${url ? '&' : ''}startBatch=${startBatch}`
        }

        if (endBatch) {
          url += `${url ? '&' : ''}endBatch=${endBatch}`
        }

        if (completionStart) {
          url += `${url ? '&' : ''}completionStart=${completionStart}`
        }

        if (completionEnd) {
          url += `${url ? '&' : ''}completionEnd=${completionEnd}`
        }
        if (attendanceBacklisted) {
          url += `${url ? '&' : ''}attendanceBacklisted=${attendanceBacklisted}`
        }

        // Append conductBacklisted if present
        if (conductBacklisted) {
          url += `${url ? '&' : ''}conductBacklisted=${conductBacklisted}`
        }

        // Append collegeFeeBacklisted if present
        if (collegeFeeBacklisted) {
          url += `${url ? '&' : ''}collegeFeeBacklisted=${collegeFeeBacklisted}`
        }

        setUrl(`${url}&searchBy=${search?.trim()}`)
      } else if (currentUrl?.includes('searchBy')) {
        const searchParams = new URLSearchParams(currentUrl)
        searchParams.delete('searchBy')
        setUrl(`${searchParams}`)
      } else {
        setUrl('')
      }
    }
    setCurrentPage(0)
  }, [debounced])

  const sortFilter = sort => {
    let sortOrder = orderBy
    if (sort === sortBy) {
      if (sortOrder === 'asc') {
        sortOrder = 'desc'
      } else if (sortOrder === 'desc') {
        sortOrder = ''
        sort = ''
      } else {
        sortOrder = 'asc'
      }
    } else {
      sortOrder = 'asc'
    }
    setOrderBy(sortOrder)
    setSortBy(sort)
    if (!sortOrder && !sort) {
      onSortValueChanged('')
    }
    //  else if (checkHeaderData?.text === 'Opt-ed Out') {
    //   const optedStatus = tabsData?.split('=')[1]
    //   onSortValueChanged(
    //     `&optedStatus=${optedStatus}&sort=${sort}&orderBy=${sortOrder}`
    //   )
    // }
    else {
      onSortValueChanged(`sort=${sort}&orderBy=${sortOrder}`)
    }
  }

  const handleUnRestrictedClick = () => {
    setShowDeclinedDrawer(true)
  }
  const handleBlacklistedClick = () => {
    setShowBlacklistedDrawer(true)
  }
  const handleOptOutClick = () => {
    setShowOptOutDrawer(false)
    setShowSuccessPopup(true)
    const payload = {
      studentIds: selectAll ? [] : selectedStudents,
      instituteCampusId: instituteCampusId,
      action: approvalStatus == 'approval' ? 'approve' : 'reject',
      selectAll: selectAll,
      // searchBy: search,
      optedStatus: tabsData?.split('=')[1],
      // approvalStatus: approvalStatus,
    }

    SelectOptOutlist(payload)
    setSelectAll(false)
    setSelectedStudents([])
    setSelectedUniqueStudents([])
    getStudentsListData(
      null,
      `pageLimit=10&pageNo=0&optedOut=true&optedStatus=${payload?.optedStatus}`
    )
  }
  const onTemporaryCloseClick = () => {
    getStudentsListData(
      null,
      `pageLimit=10&pageNo=0&optedOut=true&optedStatus=${
        tabsData?.split('=')[1]
      }`
    )
  }
  const handleDeclineCloseClick = () => {
    setSelectedStudents([])
    setSelectedUniqueStudents([])
    getStudentsListData(null, 'pageLimit=10&pageNo=0&isRestricted=true')
  }
  const handleBlacklistCloseClick = () => {
    setSelectedStudents([])
    setSelectedUniqueStudents([])
    getStudentsListData(null, 'pageLimit=10&pageNo=0&status=-1')
  }
  const handleApproveClick = () => {
    setShowDeclinedDrawer(false)
    setShowDeclinePopup(true)
    const payload = {
      studentIds: selectedStudents,
      instituteCampusId: instituteCampusId,
      selectAll: selectAll,
      searchBy: search,
    }
    SelectUnRestricted(payload)
    setSelectAll(false)
    setSelectedStudents([])
    setSelectedUniqueStudents([])
  }
  const handleBlacklistApproveClick = () => {
    setShowBlacklistedDrawer(false)
    setShowBlacklistPopup(true)
    const payload = {
      studentIds: selectedStudents,
      instituteCampusId: instituteCampusId,
      selectAll: selectAll,
      searchBy: search,
    }
    SelectBlacklist(payload)
    setSelectAll(false)
    setSelectedStudents([])
    setSelectedUniqueStudents([])
    getStudentsListData(null, 'pageLimit=10&pageNo=0&status=-1')
  }
  const handleOptOutApproveClick = value => {
    setShowOptOutDrawer(true)
    setApprovalStatus(value)
  }

  const handleOptOutRejectClick = value => {
    setShowOptOutDrawer(true)
    setApprovalStatus(value)
  }

  const handleOpenConsentReasonDrawer = async (studentId, record) => {
    const reasonList = record?.restrictedReason
    let updatedPayload = {}

    if (reasonList?.isAbsentLimit && !reasonList?.isAbsentLimit.isEligible) {
      updatedPayload.isAbsentList = true
    }

    if (
      reasonList?.isInitialMissedRole &&
      !reasonList?.isInitialMissedRole.isEligible
    ) {
      updatedPayload.isInitialMissedRole = true
    }

    try {
      const consentDrawerReasonResponse = await getConsentDrawerList(
        studentId,
        updatedPayload
      )

      if (consentDrawerReasonResponse.status == 200) {
        setRolesData(consentDrawerReasonResponse?.data)
        setConsentReasonData(consentDrawerReasonResponse?.data)
        setConsentReasonDrawer(true)
      } else {
        //console.log('No data received or error occurred.')
      }
    } catch (error) {
      console.error('Error opening consent reason drawer:', error)
    }
  }
  const handleDownload = async () => {
    if (selectedStudents?.length <= 10 && !selectAll) {
      setPopUp(true)
    } else {
      setBulkDownload(true)
    }
  }
  const handleCloseConsentReasonDrawer = () => {
    setConsentReasonDrawer(false)
  }

  const columns = [
    {
      title: 'Roll Number',
      dataIndex: 'uniRollNo',
      hidden:
        checkHeaderData?.text === 'Restricted Students' ||
        checkHeaderData?.text === 'Blacklisted' ||
        checkHeaderData?.text === 'Opt-ed Out',
      // sorter: true,
      // sortDirections: ['ascend', 'descend'],
      render: (text, data) => (
        <Flex spaceBetween>
          <StyledPNew textType="uppercase">{text || '-'}</StyledPNew>
          {(data?.backlistedReason?.badConduct ||
            data?.backlistedReason?.feeNotPaid ||
            data?.backlistedReason?.lowAttendance) && (
            <Tooltip
              placement={'bottomLeft'}
              title={
                <OverlayFlex column>
                  <BlacklistHeading>Blacklisted for</BlacklistHeading>
                  <ul>
                    {data?.backlistedReason?.badConduct && (
                      <StyledLi>Bad Conduct</StyledLi>
                    )}
                    {data?.backlistedReason?.feeNotPaid && (
                      <StyledLi>Fee Not Paid</StyledLi>
                    )}
                    {data?.backlistedReason?.lowAttendance && (
                      <StyledLi>Low Attendence</StyledLi>
                    )}
                  </ul>
                </OverlayFlex>
              }
            >
              <div>
                <BlacklistIcon />
              </div>
            </Tooltip>
          )}
        </Flex>
      ),
      // onHeaderCell: column => {
      //   return {
      //     onClick: () => {
      //       sortFilter('uniRollNo')
      //     },
      //   }
      // },
    },
    {
      title: 'Student Name',
      dataIndex: 'firstName',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('firstName')
          },
        }
      },
      render: (text, item) => (
        <StyledP
          style={{
            color: 'rgba(50, 73, 215, 1)',
            fontWeight: '600',
            cursor: 'pointer',
          }}
          onClick={() => {
            setSelectedStudentId(item.id)
            setIsOpenHistory(true)
          }}
        >
          {item?.firstName} {item?.middelName} {item?.lastName}
        </StyledP>
      ),
    },
    {
      title: 'Batch',
      dataIndex: 'batch',
      sorter: true,
      hidden:
        checkHeaderData?.text === 'Restricted Students' ||
        checkHeaderData?.text === 'Blacklisted' ||
        checkHeaderData?.text === 'Opt-ed Out',
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('startedOn')
          },
        }
      },
      render: (text, item) => {
        const startedOn = item?.currentCourse?.startedOn
        const endedOn = item?.currentCourse?.endedOn
        
        // Convert to number and check if it's 0, null, or undefined
        const startedOnNum = startedOn ? Number(startedOn) : null
        const endedOnNum = endedOn ? Number(endedOn) : null
        const isStartedOnInvalid = !startedOnNum || startedOnNum === 0
        const isEndedOnInvalid = !endedOnNum || endedOnNum === 0

        return (
          <StyledP>
            {isStartedOnInvalid && isEndedOnInvalid ? (
              '-'
            ) : isStartedOnInvalid ? (
              <>
                {new Date(endedOnNum * 1).getFullYear()}
              </>
            ) : (
              <>
                {new Date(startedOnNum * 1).getFullYear()}{' '}
                {'-'}{' '}
                {new Date(endedOnNum * 1).getFullYear()}
              </>
            )}
          </StyledP>
        )
      },
    },

    {
      title: 'Contact Details',
      dataIndex: 'contact details',
      hidden:
        checkHeaderData?.text !== 'Restricted Students' &&
        checkHeaderData?.text !== 'Blacklisted' &&
        checkHeaderData?.text !== 'Opt-ed Out',
      // sorter: checkHeaderData?.text == 'Opt-ed Out' ? false : true,
      // sortDirections: ['ascend', 'descend'],
      // onHeaderCell: column => {
      //   return {
      //     onClick: () => {
      //       sortFilter('degree')
      //     },
      //   }
      // },
      render: (text, data) => (
        <>
          <StyledP>{data?.studentPersonalProfile?.phoneNumber}</StyledP>
          <StyledEmail>
            {data?.studentPersonalProfile?.primaryEmail?.toLowerCase()}
          </StyledEmail>
        </>
      ),
    },
    {
      title: 'Deg & Department',
      dataIndex: 'deg_department',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('degree')
          },
        }
      },
      render: (text, data) => (
        <>
          <StyledP>{data?.currentCourse?.degree}</StyledP>
          <StyledSubTitle>{data?.currentCourse?.department}</StyledSubTitle>
        </>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: true,
      hidden:
        checkHeaderData?.text === 'Restricted Students' ||
        checkHeaderData?.text === 'Blacklisted' ||
        checkHeaderData?.text === 'Opt-ed Out',
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('status')
          },
        }
      },
      render: status => <StudentStatus status={status} />,
    },
    {
      title: 'CONSENT REASON',
      dataIndex: 'consent reason',
      hidden: checkHeaderData?.text !== 'Restricted Students',
      render: (_, data) => {
        const reasons = [
          data?.restrictedReason?.isInitialMissedRole?.limit &&
            (data.restrictedReason.isInitialMissedRole.limit > 1
              ? `Missed initial <strong>${data.restrictedReason.isInitialMissedRole.limit} roles.</strong>`
              : `Missed initial <strong>${data.restrictedReason.isInitialMissedRole.limit} role.</strong>`),
          data?.restrictedReason?.isAbsentLimit?.limit &&
            `Failed to attend <strong>${data?.restrictedReason?.isAbsentLimit.limit} scheduled evaluations.</strong>`,
        ].filter(Boolean)

        return (
          <EmptyElement
            style={{ cursor: 'pointer' }}
            onClick={() => handleOpenConsentReasonDrawer(data.id, data)}
          >
            {reasons.map((reason, index) => (
              <StyledP
                key={index}
                style={{ marginBottom: '8px', color: '#3A53F3' }}
                dangerouslySetInnerHTML={{ __html: reason }}
              />
            ))}
          </EmptyElement>
        )
      },
    },

    {
      title: 'RESTRICTED FROM',
      dataIndex: 'restricted  From',
      hidden: checkHeaderData?.text !== 'Restricted Students',
      render: (text, data) => {
        let formattedDate
        if (!data?.restrictedDate) {
          formattedDate = '-'
        } else {
          const dateObj = new Date(data?.restrictedDate)
          const day = String(dateObj?.getUTCDate())?.padStart(2, '0')
          const month = String(dateObj?.getUTCMonth() + 1)?.padStart(2, '0')
          const year = dateObj?.getUTCFullYear()
          formattedDate = `${day}/${month}/${year}`
        }
        return (
          <>
            <StyledP>{formattedDate}</StyledP>
          </>
        )
      },
    },
    {
      title: 'Blacklisted Reason',
      dataIndex: 'blacklist reason',
      hidden: checkHeaderData?.text !== 'Blacklisted',
      render: (_, data) => {
        const reasons = [
          data?.currentCourse?.attendanceBacklisted && 'Not enough attendance',
          data?.currentCourse?.collegeFeeBacklisted && 'Fees not paid',
          data?.currentCourse?.conductBacklisted && 'Bad conduct',
        ].filter(Boolean)

        return (
          <div>
            {reasons.map((reason, index) => (
              <StyledP
                key={index}
                style={{ marginBottom: '8px', color: '#000000' }}
              >
                {reason}
              </StyledP>
            ))}
          </div>
        )
      },
    },

    {
      title: 'Blacklisted On',
      dataIndex: 'blacklist on',
      hidden: checkHeaderData?.text !== 'Blacklisted',
      render: (text, data) => {
        let formattedDate
        if (!data?.currentCourse?.blockListedDate) {
          formattedDate = '-'
        } else {
          const dateObj = new Date(data?.currentCourse?.blockListedDate)
          const day = String(dateObj?.getUTCDate())?.padStart(2, '0')
          const month = String(dateObj?.getUTCMonth() + 1)?.padStart(2, '0')
          const year = dateObj?.getUTCFullYear()
          formattedDate = `${day}/${month}/${year}`
        }

        return (
          <>
            <StyledP>{formattedDate}</StyledP>
          </>
        )
      },
    },

    {
      title: 'completion',
      dataIndex: 'profileCompletionPerc',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      hidden:
        checkHeaderData?.text === 'Restricted Students' ||
        checkHeaderData?.text === 'Blacklisted' ||
        checkHeaderData?.text === 'Opt-ed Out',
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('profileCompletionPerc')
          },
        }
      },
      render: data => <ProgressCircle progressRate={data} width="30px" />,
    },
    {
      title:
        tabsData === 'optedStatus=opt-out-pending'
          ? 'Opting Out Reason'
          : 'Opt-ed out reason',
      dataIndex: 'opt-ed out reason',
      hidden: checkHeaderData?.text !== 'Opt-ed Out',
      render: (_, data) => {
        const reasons = [
          data?.currentCourse?.optoutType === 'OTHERS'
            ? data?.currentCourse?.optoutReason
            : getOptOutType(data?.currentCourse?.optoutType),
        ].filter(Boolean)

        return (
          <div>
            {reasons.map((reason, index) => (
              <StyledP
                key={index}
                style={{ marginBottom: '8px', color: '#000000' }}
              >
                {reason}
              </StyledP>
            ))}
          </div>
        )
      },
    },
    {
      title: 'Opt-ed OUT on',
      dataIndex: 'opt-ed out on',
      hidden:
        checkHeaderData?.text !== 'Opt-ed Out' ||
        tabsData === 'optedStatus=opt-out-pending',
      render: (_, data) => {
        const date = new Date(data?.currentCourse?.optoutDate)

        const formattedDate = date.toLocaleDateString('en-GB')
        const reasons = [formattedDate || ''].filter(Boolean)

        return (
          <div>
            {reasons.map((reason, index) => (
              <StyledP
                key={index}
                style={{ marginBottom: '8px', color: '#000000' }}
              >
                {reason}
              </StyledP>
            ))}
          </div>
        )
      },
    },
    {
      title: 'Action',
      dataIndex: 'id',
      hidden:
        checkHeaderData?.text === 'Opt-ed Out' ||
        (!cruds?.includes('ACTIVE/INACTIVE') &&
          !cruds?.includes('BLACKLIST') &&
          !cruds?.includes('DELETE') &&
          !cruds?.includes('EDIT')),
      render: (id, data) => (
        <ActionsStudent
          studentId={id}
          data={data}
          getSingleStudentData={getSingleStudentData}
          deleteStudent={deleteStudent}
          singleStudentData={singleStudentData}
          onEditStudent={onEditStudent}
          blacklistStudent={blacklistStudent}
          activeInactivateStatus={activeInactivateStatus}
          reInviteStudent={reInviteStudent}
          cruds={cruds}
          eventId={eventId}
          matchingTemplate={matchingTemplate}
          sendNotificationEmail={sendNotificationEmail}
          setCurrentPage={setCurrentPage}
          currentUrl={currentUrl}
          counter={counter}
          setCounter={setCounter}
          setSelectedStudents={setSelectedStudents}
          viewOnly={
            checkHeaderData?.text === 'Restricted Students' ||
            checkHeaderData?.text === 'Blacklisted'
          }
          getJobRolePreview={getJobRolePreview}
          getStudentPlacedList={getStudentPlacedList}
          getPlacementHistoryList={getPlacementHistoryList}
          getPreview={getPreview}
        />
      ),
    },
  ].filter(item => !item.hidden)

  useEffect(() => {
    if (selectAll && studentsList?.data?.result) {
      const currentPageKeys = studentsList.data.result.map(item => item.id)
      // When selectAll is true, ensure current page students are in selectedStudents
      setSelectedStudents(prevSelected => {
        const newSelected = [...prevSelected]
        currentPageKeys.forEach(key => {
          if (!newSelected.includes(key)) {
            newSelected.push(key)
          }
        })
        return newSelected
      })
    }
  }, [selectAll, studentsList?.data?.result])

  const rowSelection = {
    selectedRowKeys: selectedStudents || [],
    onChange: (selectedRowKeys, selectedRows) => {
      const filteredIds = selectedRows
        .filter(record => !record.isDisable)
        .map(record => record.id)
      setSelectedUniqueStudents(filteredIds)
      setSelectedStudents(selectAll === true ? [] : selectedRowKeys)
      setSelectAll(false)
    },
    getCheckboxProps: record => ({
      // disabled: record.isDisable &&
      //   !(checkHeaderData?.text === 'Restricted Students' || checkHeaderData?.text === 'Blacklisted' || checkHeaderData?.text === 'Opt-ed Out'),
      roles: record.roles,
    }),
  }

  const paginationChange = (page, pageSize) => {
    setUrl(`${currentUrl}`)
    setCurrentPage(page - 1)
  }
  const changeFilters = filter => {
    // Handle empty filters (empty string or empty array)
    if (!filter || filter?.length === 0 || filter === '') {
      const urlParams = new URLSearchParams(currentUrl)
      // Remove all filter-related parameters
      urlParams.delete('status')
      urlParams.delete('startBatch')
      urlParams.delete('endBatch')
      urlParams.delete('degreeStreamMapIds')
      urlParams.delete('specializationId')  
      urlParams.delete('specialisationId') 
      urlParams.delete('specialisationIds')  
      urlParams.delete('completionStart')
      urlParams.delete('completionEnd')
      urlParams.delete('attendanceBacklisted')
      urlParams.delete('conductBacklisted')
      urlParams.delete('collegeFeeBacklisted')
      
      const newUrl = urlParams.toString()
      setUrl(newUrl)
    } else {
      if (filter.length > 0) {
        if (search && search.trim().length > 0) {
          setUrl(`${filter}&searchBy=${search.trim()}`)
        } else {
          setUrl(`${filter}`)
        }
      } else if (currentUrl?.includes('&')) {
        const [baseUrl, queryString] = currentUrl.split('&')
        setUrl(`${filter}&${queryString.toString()}`)
      } else {
        if (search && search.trim().length > 0) {
          setUrl(`${filter}&searchBy=${search.trim()}`)
        } else {
          setUrl(filter)
        }
      }
    }
    setCurrentPage(0)
  }

  const onTabChange = tab => {
    setTabsData(tab.query)
    setUrlQuery(tab.query)
    setNewUrlQuery(tab.query)
    // setCheckHeaderData({
    //   ...tab,
    //   filter: tab.query,
    //   isSelected: true,
    // })
    setSearch('')
    setSelectAll(false)
    setSelectedUniqueStudents([])
    setSelectedStudents([])
  }

  return (
    <NavWrapper column>
      {checkHeaderData?.text === 'Opt-ed Out' && (
        <AntdTabs
          tabs={tabs}
          selected={selected}
          setSelected={setSelected}
          onTabChange={onTabChange}
        />
      )}
      <TableTop
        style={{
          borderBottom: '1px solid #d9d9d9',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <NavBarLayoutFirst>
          <SearchInput
            searchValue={search}
            width={'100%'} // take full space in this group
            placeholder="Search by student name"
            bordered={false}
            setSearchValue={text => setSearch(text)}
          />
          <StyledDivider />
          <div style={{ display: 'flex', gap: '10px' }}>
            <div
              style={{
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                opacity: isDisabled ? 0.5 : 1,
                display: 'inline-block',
              }}
              onClick={e => {
                e.stopPropagation() // prevent event bubbling
                if (!isDisabled) {
                  handleDownload()
                }
              }}
            >
              <ResumeDownload />
            </div>

            <div
              style={{
                cursor: resendDisabled ? 'not-allowed' : 'pointer',
                opacity: resendDisabled ? 0.5 : 1,
                display: 'inline-block',
              }}
              onClick={e => {
                e.stopPropagation() // 🔥 prevent event bubbling
                if (!resendDisabled) {
                  handleResendClick()
                }
              }}
            >
              <ResendIntiveIcon />
            </div>
          </div>
        </NavBarLayoutFirst>

        <NavBarLayoutSecond>
          <StudentFilter
            cardData={cardsData}
            setQuery={changeFilters}
            degreeList={degreeList}
            filterData={filterData}
            setFilterData={setFilterData}
            batchValue={batchValue}
            setBatchValue={setBatchValue}
            cardsDetails={cardsDetails}
            rangeValue={rangeValue}
            setRangeValue={setRangeValue}
            setSelectedStudents={setSelectedStudents}
            currentUrl={currentUrl}
            checkedDegreeData={checkedDegreeData}
            setCheckedDegreeData={setCheckedDegreeData}
            specializationList={extractSpecializations(degreeList)}
          />
          <FilterText>
            Showing {10 * currentPage + (studentsList?.data?.result?.length || studentsList?.result?.length || 0)} of{' '}
            {studentsList?.data?.count || studentsList?.count || 0}
          </FilterText>
        </NavBarLayoutSecond>
      </TableTop>
      {checkHeaderData?.text === 'Restricted Students' && (
        <IconContainer style={{ margin: '18px' }}>
          <IconText>Select</IconText>
          <AllowButton
            onClick={() => (isDisabled ? '' : handleUnRestrictedClick())}
            disabled={isDisabled}
          >
            <RejectIcon title={'Unrestrict'} />
          </AllowButton>
        </IconContainer>
      )}
      {checkHeaderData?.text === 'Blacklisted' && (
        <IconContainer style={{ margin: '18px' }}>
          <IconText>Select</IconText>
          <AllowButton
            onClick={() => (isDisabled ? '' : handleBlacklistedClick())}
            disabled={isDisabled}
          >
            <RejectIcon title={'Unblacklist'} />
          </AllowButton>
        </IconContainer>
      )}

      {checkHeaderData?.text === 'Opt-ed Out' &&
        selected !== tabs[0]?.value && (
          <IconContainer style={{ margin: '18px' }}>
            <IconText>Select</IconText>
            <AllowButton
              onClick={() =>
                isDisabled ? '' : handleOptOutApproveClick('approval')
              }
              disabled={isDisabled}
            >
              <ShortlistIcon title={'Approve'} />
            </AllowButton>
            <AllowButton
              onClick={() =>
                isDisabled ? '' : handleOptOutRejectClick('deny approval')
              }
              disabled={isDisabled}
            >
              <RejectIcon title={'Reject'} />
            </AllowButton>
          </IconContainer>
        )}
      {/* Restricted Drawer */}
      <CloseRoleDrawer
        description={<>Selected Students for Un Restricted </>}
        Icon={ApprovedModelIcon}
        showDrawer={showDeclinedDrawer}
        setShowDrawer={setShowDeclinedDrawer}
        onCloseClick={() => setShowDeclinedDrawer(false)}
        onApprove={handleApproveClick}
        closeText="Back"
        YesText="Approve"
        closeButtonHeight="38px"
        closeButtonWidth="80px"
        yesButtonHeight="38px"
        yesButtonWidth="105px"
      />
      <SucessfullPopup
        description={
          <>
            <p>Approved for restricted student </p>
          </>
        }
        Icon={SuccessIcon}
        showDrawer={showDeclinePopup}
        setShowDrawer={setShowDeclinePopup}
        onTemporaryCloseClick={handleDeclineCloseClick}
      />
      {/* Blacklist Drawer */}
      <CloseRoleDrawer
        description={
          <>
            {selectedStudents?.length === 1
              ? 'Are you sure you want to activate the selected blacklisted student?'
              : 'Are you sure you want to activate the selected blacklisted students?'}
          </>
        }
        Icon={ApprovedModelIcon}
        showDrawer={showBlacklistedDrawer}
        setShowDrawer={setShowBlacklistedDrawer}
        onCloseClick={() => setShowBlacklistedDrawer(false)}
        onApprove={handleBlacklistApproveClick}
        closeText="Back"
        YesText="Approve"
        closeButtonHeight="38px"
        closeButtonWidth="80px"
        yesButtonHeight="38px"
        yesButtonWidth="105px"
      />
      <CloseRoleDrawer
        description={
          <>
            {selectedStudents?.length === 1
              ? `Are you sure to give ${approvalStatus} for these  ${selectedStudents?.length} student?`
              : `Are you sure to give ${approvalStatus} for these ${
                  selectAll ? 'All' : selectedStudents?.length
                } students?`}
          </>
        }
        Icon={ApprovedModelIcon}
        showDrawer={showOptOutDrawer}
        setShowDrawer={setShowOptOutDrawer}
        onCloseClick={() => setShowOptOutDrawer(false)}
        onApprove={handleOptOutClick}
        closeText="Back"
        YesText={approvalStatus
          ?.split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')}
        closeButtonHeight="38px"
        closeButtonWidth="80px"
        yesButtonHeight="38px"
        yesButtonWidth="auto"
      />
      <SucessfullPopup
        description={
          approvalStatus === 'deny approval'
            ? 'Approval denied!'
            : 'Approval given!'
        }
        Icon={
          approvalStatus === 'deny approval' ? DeclinedPopupIcon : SuccessIcon
        }
        showDrawer={showSuccessPopup}
        setShowDrawer={setShowSuccessPopup}
        onTemporaryCloseClick={onTemporaryCloseClick}
      />
      <SucessfullPopup
        description={
          <>
            <p>Approved for Active student </p>
          </>
        }
        Icon={SuccessIcon}
        showDrawer={showBlacklistPopup}
        setShowDrawer={setShowBlacklistPopup}
        onTemporaryCloseClick={handleBlacklistCloseClick}
      />
      <StyledTable
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        rowKey={record => record?.id}
        // rowKey="id"
        columns={columns}
        loading={loading}
        dataSource={studentsList?.data?.result || studentsList?.result}
        pagination={false}
      />
      <ConsentReasonDrawer
        rolesData={rolesData}
        setConsentReasonDrawer={setConsentReasonDrawer}
        consentReasonDrawer={consentReasonDrawer}
        onClose={handleCloseConsentReasonDrawer}
        consentData={consentReasonData}
        // requestList={userList?.data}
      />
      <PlacementHistoryWithResume
        studentId={selectedStudentId}
        isOpenHistory={isOpenHistory}
        setIsOpenHistory={setIsOpenHistory}
        getJobRolePreview={getJobRolePreview}
        getStudentPlacedList={getStudentPlacedList}
        getPlacementHistoryList={getPlacementHistoryList}
        getPreview={getPreview}
      />
      <Pagination
        totalPages={studentsList?.data?.count || studentsList?.count}
        pageSize={studentsList?.data?.limit || studentsList?.limit || 10}
        onChange={(page, pageSize) => {
          paginationChange(page, pageSize)
          ScrollRef()
        }}
        current={currentPage + 1}
      />
    </NavWrapper>
  )
}

export default StudentsInfoTable
